<template>
  <div class="item_mmct_page">
    <div class="page_top_img_container">
      <img src="@/assets/images/item/banner4.png" class="top_banner">
      <div class="page_content_container">
        <div class="title_with_line">
          <div class="title_line"><span>主要项目</span></div>
          <div class="title_e">Intelligence Project</div>
        </div>
        <div class="content_container">
          <img src="@/assets/images/item/logo_mmc_tang.png" class="logo_img">
          <div class="normal_size_font blod_font">MMC糖网中心是标准化代谢性疾病管理中心（MMC）的一个分支项目</div>
          <p class="lineH_desc_16">MMC糖网中心是MMC分支项目。该项目通过采集眼底照片，利用AI自动化阅片技术，依托MMC基于物联网大数据的一站式、标准化代谢性疾病综合管理平台，最终实现糖网筛查和随访管理的目标。 </p>
          <div class="normal_size_font blod_font">MMC糖网中心项目目的和意义</div>
          <p class="lineH_desc_16">做好糖尿病视网膜病变防治工作，将会提高医生和患者对糖尿病视网膜病变的重视度和糖尿病视网膜病变的筛查率，降低糖尿病患者的致盲率。通过MMC平台的大数据分析，提高糖尿病视网膜病变的防控水平，减轻患者和社会的疾病防治医疗负担。</p>
          <p class="margin_top_set"></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="less">
.item_mmct_page{
  .page_top_img_container{
    .logo_img{
      width: 90%;
      max-width: 267px;
      margin-bottom: 16px;
    }
    .content_container{
      div{
        margin-top: 20px;
        margin-bottom: 13px;
      }
      p{
        padding-bottom: 40px;
      }
    }
  }
}
</style>

